import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import Loadspinner from "../../common/Loadspinner";
import Main from "../../common/Main/Main";
import { Collapse, Modal } from "react-bootstrap";
import InputForm from "../../ReusableComponents/InputForm/InputForm";
import SelectForm from "../../ReusableComponents/SelectForm/SelectForm";
import DynamicGrid from "../../ReusableComponents/DynamicGrid/DynamicGrid";
import Button from "react-bootstrap/Button";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { del } from "../../constants/Images";
import moment from "moment";
import { getContext } from "../../helpers/Context/Context";
import * as urls from "../../helpers/API/APIEndPoints";
import {
  saveRecordMsg,
  updateRecordMsg,
  fileDeletionMsg,
} from "../../helpers/Constants/Constants";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Typography, TextField, Tooltip, Badge, Chip } from "@mui/material";
import { debounceSearchRender } from "mui-datatables";
import { APICall } from "../../helpers/API/APICalls";
import { DATE_TIME_DISPLAY_FORMAT } from "../../helpers/Constants/Constants";
import notify from "../../ReusableComponents/ToastNotification/ToastNotification";
import fileDownload from "js-file-download";
import { useHistory } from "react-router-dom";
import ViewHistory from "../../ReusableComponents/ViewHistory/ViewHistory";
import Decrypt from "../../services/Decryption";
import ResetButton from "../../ReusableComponents/Buttons/ResetButton/ResetButton";
import SubmitButton from "../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import CancelButton from "../../ReusableComponents/Buttons/CancelButton/CancelButton";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

const Dashboard = () => {
  const context = getContext();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const history = useHistory();
  const [dashboardFilterOn, setDashboardFilterOn] = useState(false);
  const [coeOptions, setCoeOptions] = useState([]);
  const [aggregateOptions, setAggregateOptions] = useState([]);
  const [platformOptions, setPlatformOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedCoe, setSelectedCoe] = useState([]);
  const [selectedAggregate, setSelectedAggregate] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [keywords, setKeywords] = useState("");
  const [kmiId, setKmiId] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [selectedTab, setSelectedTab] = useState("allRequest");
  const [dashboardData, setDashboardData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [forMyActioncount, setForMyActionCount] = useState(0);
  const [reset, setReset] = useState(false);
  const fileExtension = ".xlsx";

  const [isAdmin, setIsAdmin] = useState(
    Decrypt(getFromEncLocalStorage("ggwp") || "")
  );

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const closeHistoryModal = (confirmation) => {
    setShowHistoryModal(false);
    setHistoryId(0);
  };
  const [historyId, setHistoryId] = useState(0);

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    customSearchRender: debounceSearchRender(500),
    responsive: "standard",
    onChangeRowsPerPage: () => {
      // num
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const getDashboardData = async (isExport) => {
    setLoading(true);
    let reqFilterObj = {
      start: isExport ? 0 : start,
      resultsPerPage: isExport ? count : pageSize,
      sortColumn,
      sortDirection,
      coe:
        selectedCoe && selectedCoe.length > 0
          ? selectedCoe.map(({ value }) => value).toString()
          : "",
      aggregate:
        selectedAggregate && selectedAggregate.length > 0
          ? selectedAggregate.map(({ value }) => value).toString()
          : "",
      platform:
        selectedPlatform && selectedPlatform.length > 0
          ? selectedPlatform.map(({ value }) => value).toString()
          : "",
      status:
        selectedStatus && selectedStatus.length > 0
          ? selectedStatus.map(({ value }) => value).toString()
          : selectedTab === "forMyAction"
            ? isAdmin === "false"
              ? "3" //sendback
              : "2" //pending
            : "",
      fromDate:
        fromDate === null || fromDate === ""
          ? null
          : moment(fromDate).format("YYYY-MM-DD"),
      toDate:
        toDate === null || toDate === ""
          ? null
          : moment(toDate).format("YYYY-MM-DD"),
      keywords: keywords,
      kmiId: kmiId,
      searchText: searchText,
      isExport: isExport,
      userId: isAdmin === "false" ? getFromEncLocalStorage("employeenumber") : "", //UserId
    };
    let res = await APICall(urls.getDashboardData, reqFilterObj, "POST");
    if (isExport) {
      if (res.data !== null && res.data.type === "Buffer") {
        let byteArray = new Uint8Array(res.data.data);
        fileDownload(
          byteArray,
          `Dashboard ` +
          `${moment(new Date()).format("DD MMM YYYY")}${fileExtension}`
        ); //add time stamp
      } else {
        notify(1, "Export Failed");
      }
    } else {
      if (res.data !== null && res.data.length > 0) {
        setDashboardData(res.data);
        setCount(res.totalCount);
      } else {
        setDashboardData([]);
        setCount(0);
      }
      setForMyActionCount(selectedTab === "forMyAction" && res?.totalCount > 0 ? res?.totalCount : 0);
    }
    setLoading(false);
  };

  const getCoeDropdown = async () => {
    let requestParams = {
      dropdownName: "allCoeCommonDropdown",
      //userId: getFromEncLocalStorage("userId"), //UserId
      searchText: 2,
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST"
    );
    if (res.data !== null && res.data?.length > 0) {
      setCoeOptions(res.data);
    } else {
      notify(1, "no coe data found");
    }
  };

  const getAggregateDropdown = async () => {
    let requestParams = {
      dropdownName: "aggregateDropdown",
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST"
    );

    if (res?.data !== null && res?.data?.length > 0) {
      setAggregateOptions(res.data);
    } else {
      notify(1, "no aggreagate data found");
    }
  };

  const getPlatformDropdown = async () => {
    let requestParams = {
      dropdownName: "platformDropdown",
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST"
    );

    if (res.data !== null && res.data.length > 0) {
      setPlatformOptions(res.data);
    } else {
      notify(1, "no platform data found");
    }
  };

  const getStatusDropdown = async () => {
    let requestParams = {
      dropdownName: "status",
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST"
    );

    if (res?.data !== null && res?.data?.length > 0) {
      setStatusOptions(res.data);
    } else {
      notify(1, "no status data found");
    }
  };

  useEffect(() => {
    getCoeDropdown();
    getAggregateDropdown();
    getPlatformDropdown();
    getStatusDropdown();
  }, []);

  useEffect(() => {
    getDashboardData(false);
  }, [start, sortColumn, sortDirection, searchText, selectedTab, reset]);

  const dashboardColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: false,
      },
    },
    {
      name: "id",
      label: "Knowledge/Query Id",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "creator",
      label: "User",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "title",
      label: "Knowledge Title",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "coe",
      label: "CoE",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "aggregate",
      label: "Aggregate",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "platform",
      label: "Platform",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "created_date",
      label: "Created Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          let dateObj = moment(value);
          let dateStr = dateObj.isValid() ? dateObj.format("DD-MMM-yyyy") : "";
          return (
            <>
              <Typography component={"span"} noWrap={true}>
                {dateStr}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: "statusId",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          return (
            <div className="d-flex gap-2">
              <Tooltip
                title={
                  (isAdmin === "false" && value == 3) ||
                    (isAdmin === "true" && value == 2)
                    ? "edit"
                    : "view"
                }>
                <p className="ml-3">
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: "dashboard/edit",
                        state: {
                          id,
                          mode:
                            (isAdmin === "false" && value == 3) ||
                              (isAdmin === "true" && value == 2)
                              ? "edit"
                              : "view",
                        },
                      });
                    }}>
                    {(isAdmin === "false" && value == 3) ||
                      (isAdmin === "true" && value == 2) ? (
                      <i className="fas fa-edit"></i>
                    ) : (
                      <i className="fas fa-eye"></i>
                    )}
                  </a>
                </p>
              </Tooltip>
              <Tooltip title="history">
                <p className="ml-3">
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowHistoryModal(true);
                      setHistoryId(id);
                    }}>
                    <i className="fas fa-history"></i>
                  </a>
                </p>
              </Tooltip>
            </div>
          );
        },
      },
    },
  ];

  const resetFilter = async () => {
    setSearchText("");
    setSelectedCoe([]);
    setSelectedAggregate([]);
    setSelectedPlatform([]);
    setSelectedStatus([]);
    setFromDate(null);
    setToDate(null);
    setKeywords("");
    setKmiId("");
  };

  const onClickFunction = async (event, name) => {
    if (name === "Submit") {
      let isEmptyReqObj = false;
      if (dashboardFilterOn === true) {
        let reqFilterObj = {
          coe:
            selectedCoe && selectedCoe.length > 0
              ? selectedCoe.map(({ value }) => value).toString()
              : "",
          aggregate:
            selectedAggregate && selectedAggregate.length > 0
              ? selectedAggregate.map(({ value }) => value).toString()
              : "",
          platform:
            selectedPlatform && selectedPlatform.length > 0
              ? selectedPlatform.map(({ value }) => value).toString()
              : "",
          status:
            selectedStatus && selectedStatus.length > 0
              ? selectedStatus.map(({ value }) => value).toString()
              : "",
          fromDate:
            fromDate === null || fromDate === ""
              ? null
              : moment(fromDate).format("YYYY-MM-DD"),
          toDate:
            toDate === null || toDate === ""
              ? null
              : moment(toDate).format("YYYY-MM-DD"),
          keywords: keywords,
          kmiId: kmiId,
        };
        isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
          if (f === "" || f === null || f === undefined) {
            return true;
          } else {
            return false;
          }
        });
      }
      if (isEmptyReqObj) {
        notify(1, "select atleast one filter");
      } else if (moment(fromDate).isAfter(moment(toDate))) {
        notify(1, "From Date should be less than To Date");
      } else if (fromDate && !toDate) {
        notify(1, "Select To Date");
      } else if (toDate && !fromDate) {
        notify(1, "Select From Date");
      } else {
        getDashboardData(false);
      }
    } else if (name === "Reset") {
      resetFilter();
      setReset(!reset);
    } else if (name === "Cancel") {
      resetFilter();
      setDashboardFilterOn(false);
    }
  };

  const exportToExcelFunction = async () => {
    getDashboardData(true);
  };

  return (
    <>
      <Main active={"request"} removeContainer={true}>
        <Loadspinner filename="Dashboard.js" isLoading={loading} isMiddle="false" />
        <div className="eventGallery">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "15px" }}>
                  {isAdmin === "false" ? "Request" : "Approval"} Dashboard
                </h4>
              </div>
              <div className="col-md-4"></div>

              <div className="col-md-4" style={{ padding: "0% 3% 0% 0%" }}>
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}>
                  <button
                    className="btn btn-export"
                    style={{ marginLeft: 5 }}
                    onClick={() => {
                      if (count === 0) {
                        notify(1, "no data to download");
                      } else {
                        exportToExcelFunction();
                      }
                    }}>
                    Export To Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix"></div>
        <div className="row">
          <div className="col-lg-12">
            <div className="row justify-content-between py-2" style={{ background: "var(--theme-red)", color: "white" }}>
              <div className="col-4 align-items-center d-flex gap-2 mx-3">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedTab(() => "allRequest")}
                  className={
                    selectedTab === "allRequest"
                      ? "text-decoration-underline text-white"
                      : "text-white-50"
                  }>
                  <p>All Requests</p>
                </div>
                |
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedTab(() => "forMyAction")}
                  className={
                    selectedTab === "forMyAction"
                      ? "text-decoration-underline text-white"
                      : "text-white-50"
                  }>
                  <p>For My Action{selectedTab === "forMyAction" && <Chip label={forMyActioncount} className="mx-2" sx={{ color: "white" }} />}</p>
                </div>
              </div>
              <div className="col-4 justify-content-end align-items-center d-flex gap-3 mx-3">
                <div className="searchInput">
                  <div>
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        if (e.target.value) {
                          setSearchText(e.target.value);
                        } else {
                          setSearchText("");
                        }
                      }}
                    />
                    {/* <i
                      style={{ marginRight: "-10px", marginTop: "-3px" }}
                      className="fas fa-search"
                      aria-hidden="true"></i> */}
                  </div>
                </div>
                <p
                  className="btn"
                  style={{ cursor: "pointer" }}
                  onClick={() => setDashboardFilterOn((prev) => !prev)}>
                  <FilterAltIcon sx={{ color: "white" }} />
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <Collapse in={dashboardFilterOn}>
                <div className="filter-content pt-2 mx-3" style={{ display: "" }}>
                  <div className="row">
                    <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">COE</label>
                        <SelectForm
                          options={coeOptions}
                          placeholder="Select"
                          isDisabled={false}
                          value={selectedCoe}
                          onChange={(event) => setSelectedCoe(event)}
                          isMulti={true}
                          noIndicator={false}
                          noSeparator={false}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">Aggregate</label>
                        <SelectForm
                          options={aggregateOptions}
                          placeholder="Select"
                          isDisabled={false}
                          value={selectedAggregate}
                          onChange={(event) => setSelectedAggregate(event)}
                          isMulti={true}
                          noIndicator={false}
                          noSeparator={false}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">Platform</label>
                        <SelectForm
                          options={platformOptions}
                          placeholder="Select"
                          isDisabled={false}
                          value={selectedPlatform}
                          onChange={(event) => setSelectedPlatform(event)}
                          isMulti={true}
                          noIndicator={false}
                          noSeparator={false}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">Status</label>
                        <SelectForm
                          options={statusOptions}
                          placeholder="Select"
                          isDisabled={false}
                          value={selectedStatus}
                          onChange={(event) => setSelectedStatus(event)}
                          isMulti={true}
                          noIndicator={false}
                          noSeparator={false}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">From Date</label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label=" "
                            style={{ marginTop: "5px" }}
                            value={fromDate}
                            onChange={(e) => setFromDate(e)}
                            inputFormat="dd/MM/yyyy"
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  backgroundColor: "white",
                                  display: "flex",
                                }}
                                size="small"
                                {...params}
                                error={false}
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                        <p style={{ color: "red" }}>
                          {formErrors["EventFromDate_isEmpty"]}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">To Date</label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label=" "
                            style={{ marginTop: "5px" }}
                            value={toDate}
                            onChange={(e) => setToDate(e)}
                            inputFormat="dd/MM/yyyy"
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  backgroundColor: "white",
                                  display: "flex",
                                }}
                                size="small"
                                {...params}
                                error={false}
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                        <p style={{ color: "red" }}>
                          {formErrors["EventFromDate_isEmpty"]}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">Keywords</label>
                        <InputForm
                          className=""
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={keywords}
                          onChange={(e) => setKeywords(e.target.value)}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["kmiId_isEmpty"]}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                      <div className="form-group">
                        <label className="col-form-label">KMI ID</label>
                        <InputForm
                          className=""
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={kmiId}
                          onChange={(e) => setKmiId(e.target.value)}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["kmiId_isEmpty"]}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <div className="float-right">
                        {/* <button
                          className="btn btn-submit"
                          style={{ marginLeft: 5 }}
                          onClick={(e) => onClickFunction(e, "Submit")}>
                          Apply
                        </button> */}
                        <SubmitButton
                          title="Apply"
                          onClick={(e) => onClickFunction(e, "Submit")}
                        />
                        {/* <button
                          className="btn btn-info"
                          style={{ marginLeft: 5 }}
                          onClick={(e) => onClickFunction(e, "Reset")}>
                          Reset
                        </button> */}
                        <ResetButton
                          onClick={(e) => onClickFunction(e, "Reset")}
                        />
                        {/* <button
                          className="btn btn-cancel"
                          style={{ marginLeft: 5 }}
                          onClick={(e) => onClickFunction(e, "Cancel")}>
                          Cancel
                        </button> */}
                        <CancelButton
                          onClick={(e) => onClickFunction(e, "Cancel")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>

          <div className="col-lg-12">
            {selectedTab === "allRequest" ? (
              <>
                <DynamicGrid
                  options={options}
                  data={dashboardData}
                  columns={dashboardColumns}
                />
              </>
            ) : (
              <>
                <DynamicGrid
                  options={options}
                  data={dashboardData}
                  columns={dashboardColumns}
                />
              </>
            )}
          </div>
        </div>
      </Main >
      <>
        <Modal
          show={showHistoryModal}
          onHide={() => closeHistoryModal(false)}
          backdrop="static"
          keyboard={false}
          size="xl"
          centered>
          <div
            style={{
              background: "var(--theme-red)",
              padding: "10px",
              color: "white",
            }}>
            <div className="col-lg-12">History</div>
          </div>
          <ViewHistory id={historyId} />
          <Modal.Footer>
            <button
              className="btn btn-dark"
              style={{ marginLeft: 5 }}
              onClick={() => closeHistoryModal(false)}>
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </>
    </>
  );
};

export default Dashboard;
